import { useState } from 'react'

import { API } from '@/api'
import PencilIcon from '@/assets/icons/pencil.svg?react'
import { LabelType } from '@/consts/machine'
import { Snapshot } from '@/models/snapshot'

interface EditableSnapshotNameProps {
  snapshot: Snapshot
  onUpdate: () => void
}

export function EditableSnapshotName({ snapshot, onUpdate }: EditableSnapshotNameProps) {
  const [isEditing, setIsEditing] = useState(false)
  const [label, setLabel] = useState(snapshot.name)

  const handleBlur = async () => {
    setIsEditing(false)
    const newLabel = label.trim()
    if (newLabel === snapshot.name) {
      return
    }

    if (newLabel === '') {
      return
    } else {
      if (snapshot.flagID) {
        await API.modifyLabel({
          id: Number(snapshot.flagID),
          subject: newLabel,
          type: LabelType.Snapshot,
        })
      }
      onUpdate()
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      (e.target as HTMLInputElement).blur()
    }
  }

  if (isEditing) {
    return (
      <input
        className="bg-neutral-100 h-6 w-full px-2 py-0.5 t-sb focus-within:outline-none rounded-md"
        name="name"
        autoFocus
        value={label}
        maxLength={30}
        onChange={(e) => setLabel(e.target.value)}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
      />
    )
  }

  return (
    <div className="t-sb flex items-center">
      {snapshot.name}
      <PencilIcon
        className="w-4 h-4 ml-2 text-highlight cursor-pointer hidden group-hover:inline-block"
        onClick={(e) => {
          e.stopPropagation()
          setIsEditing(true)
        }}
      />
    </div>
  )
}
